import React from "react";

export const inputCls =
  "w-full rounded-lg border border-hairline bg-white px-3.5 py-2.5 text-[15px] text-ink placeholder:text-ink/40 focus:border-electric focus:ring-2 focus:ring-electric/20 focus:outline-none transition-colors";

export function Field({ label, required, children, error, hint, as: Tag = "label" }) {
  return (
    <Tag className="block">
      <span className="mb-1.5 block text-sm font-medium text-navy">
        {label} {required && <span className="text-electric">*</span>}
      </span>
      {children}
      {hint && !error && <span className="mt-1 block text-xs text-ink/50">{hint}</span>}
      {error && <span className="mt-1 block text-xs font-medium text-red-600">{error}</span>}
    </Tag>
  );
}

export function TextInput({ error, ...props }) {
  return <input className={`${inputCls} ${error ? "border-red-400" : ""}`} {...props} />;
}

export function TextArea({ error, ...props }) {
  return <textarea rows={3} className={`${inputCls} resize-none ${error ? "border-red-400" : ""}`} {...props} />;
}

export function SelectInput({ error, children, ...props }) {
  return (
    <select className={`${inputCls} ${error ? "border-red-400" : ""}`} {...props}>
      {children}
    </select>
  );
}

export function Consent({ checked, onChange, testid = "consent-checkbox" }) {
  return (
    <label className="flex items-start gap-3 rounded-lg border border-hairline bg-white p-3.5">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 accent-electric"
        data-testid={testid}
      />
      <span className="text-sm text-ink/70">
        Jeg samtykker til at MobilHub lagrer og behandler opplysningene mine for å svare på
        henvendelsen, i tråd med personvernreglene (GDPR).
      </span>
    </label>
  );
}
